import React from 'react'

export const CheckboxActvone = ({ text, value, checkboxStates, handleCheckboxChange }) => {
	return (
		<div className='w-full h-10 md:h-20 bg-white flex'>
			<div className='w-[128px] md:w-[316px] h-full bg-white flex justify-start items-center pl-4 md:pl-6'>
				<p className='text-sm'>{text}</p>
			</div>
			<div className='w-[56px] md:w-[143px] h-full bg-gray-200 flex justify-around items-center '>
				<input className='w-6 md:w-10 h-6 md:h-10' type="checkbox"
					checked={checkboxStates[value]}
					onChange={() => handleCheckboxChange(value)}
				/>
			</div>
			<div className='w-[56px] md:w-[143px] h-full bg-white flex justify-around items-center '></div>
			<div className='w-[56px] md:w-[143px] h-full bg-gray-200 flex justify-around items-center '></div>
		</div>
	)
}
